import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FS } from "src/configs/constance";
import NFTCoreContract from "src/contract-logic/logic/NFTCoreContract";
import NFTManagerContract from "src/contract-logic/logic/NFTManagerContract";
import multiCall from "src/utils/multicall";

const initialState = {
  unopenedChest: { v1: [], v2: [], total: 0 },
  totalOwnerChests: 0,
  numberOfChests: 0,
  fetchingUnopenedChest: FS.INITIAL,
};

export const getAvailableChest = createAsyncThunk("chest/getAvailableChest", async (_, thunkAPI) => {
  const accountAddress = thunkAPI.getState().accountSlice.address;
  thunkAPI.dispatch(chestSlice.actions.setFetching({ type: "unopenedChest", status: FS.FETCHING }));
  const tokenLength = await NFTCoreContract.getBalance(accountAddress);
  const [tokenIds] = await Promise.all([
    multiCall(
      NFTCoreContract.ABI,
      new Array(tokenLength).fill(1).map((_, idx) => ({
        address: NFTCoreContract.ADDRESS,
        name: "tokenOfOwnerByIndex",
        params: [accountAddress, idx],
      }))
    ),
  ]);
  const tokenIdsFlattened = tokenIds.flat();
  thunkAPI.dispatch(push({ totalOwnerChests: tokenIdsFlattened.length }));

  const [data] = await Promise.all([
    multiCall(
      NFTManagerContract.ABI,
      tokenIdsFlattened.map((tokenId) => ({
        address: NFTManagerContract.ADDRESS,
        name: "checkIfChestOpenedAndSet",
        params: [tokenId],
      }))
    ),
  ]);
  const v1 = [];
  const v2 = [];
  tokenIdsFlattened.forEach((tokenId, index) => {
    const version = parseInt(data[index][0]);
    const isOpen = data[index][1];
    if (!isOpen) {
      if (version == 1) v1.push(parseInt(tokenId));
      else v2.push(parseInt(tokenId));
    }
  });
  return { v1, v2, total: v1.length + v2.length };
});

export const fetchRemainingChests = createAsyncThunk("chest/fetchRemainingChests", async (_) => {
  return await NFTManagerContract.getCirculatingLimit();
});

const chestSlice = createSlice({
  name: "chestSlice",
  initialState: initialState,
  reducers: {
    push(state, action) {
      Object.assign(state, action.payload);
    },
    setFetching(state, action) {
      const type = action.payload.type;
      if (type == "unopenedChest") state.fetchingUnopenedChest = action.payload.status;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getAvailableChest.fulfilled, (state, action) => {
        state.unopenedChest = action.payload;
        state.fetchingUnopenedChest = FS.SUCCESS;
      })
      .addCase(getAvailableChest.rejected, (state, action) => {
        console.error(action);
        state.unopenedChest = [];
        state.fetchingUnopenedChest = FS.FAIL;
      })
      .addCase(fetchRemainingChests.fulfilled, (state, action) => {
        state.numberOfChests = action.payload;
      })
      .addCase(fetchRemainingChests.rejected, (state, action) => {
        console.error(action);
        state.numberOfChests = 0;
      }),
});

export default chestSlice.reducer;
export const { push } = chestSlice.actions;
